import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

const STARTED_AT_KEY = "flittCheckoutStartedAt"
const MAX_AGE_MS = 60 * 60 * 1000

// Brings the "What stopped you?" prompt (checkout_feedback_controller) up on the paywall a
// learner comes Back to from the Flitt checkout. The browser shows that page from its
// back/forward or HTTP cache, as it was before the order existed, so the layout could not
// have rendered the prompt into it: reload it once.
//
// The pay form marks the tab on submit. Only a Back/Forward return to this tab within the
// hour reloads, and only when the page has no prompt yet (a fresh render already has it).
// The app returns differently (MainActivity reloads every tab), so only the web form
// carries this.
//
//   <form data-controller="checkout-return" data-action="submit->checkout-return#mark">
export default class extends Controller {
  connect() {
    this.onPageShow = (event) => {
      if (event.persisted) this.reloadIfReturned()
    }
    window.addEventListener("pageshow", this.onPageShow)

    if (performance.getEntriesByType?.("navigation")?.[0]?.type === "back_forward") this.reloadIfReturned()
  }

  disconnect() {
    window.removeEventListener("pageshow", this.onPageShow)
  }

  mark() {
    try {
      sessionStorage.setItem(STARTED_AT_KEY, String(Date.now()))
    } catch {
      // Storage blocked: the prompt then shows on the next page instead.
    }
  }

  reloadIfReturned() {
    let startedAt
    try {
      startedAt = Number(sessionStorage.getItem(STARTED_AT_KEY))
      sessionStorage.removeItem(STARTED_AT_KEY)
    } catch {
      return
    }
    if (!startedAt || Date.now() - startedAt > MAX_AGE_MS) return
    if (document.getElementById("checkout_feedback")) return

    Turbo.visit(window.location.href, { action: "replace" })
  }
}
